import {
  GOHIGHLEVEL_ACCOUNTS,
  GOHIGHLEVEL_LOCATIONS,
  GOHIGHLEVEL_OAUTH_URL,
  GOHIGHLEVEL_REVOKE_TOKEN,
} from '@mm/api-routes';
import AuthenticatedController from './AuthenticatedController';

export default class GoHighLevelController extends AuthenticatedController {
  static async getOauthUrl(tokenId?: number) {
    const query = tokenId ? { token_id: tokenId } : undefined;
    return super.get(GOHIGHLEVEL_OAUTH_URL, query);
  }
  static async getLocations(
    facebookPageId: number,
    tokenId: number,
    force: boolean = false,
  ) {
    return super.get(GOHIGHLEVEL_LOCATIONS, {
      facebook_page_id: facebookPageId,
      token_id: tokenId,
      force,
    });
  }
  static async getAccounts(facebokPageId: number) {
    return super.get(GOHIGHLEVEL_ACCOUNTS, {
      facebook_page_id: facebokPageId,
    });
  }
  static async revokeAccess(accountId: number) {
    return super.post(GOHIGHLEVEL_REVOKE_TOKEN, {
      account_id: accountId,
    });
  }
}
